import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOnClickOutside } from "../customHooks/useOnClickOutside";
import { userLoginAction, userLogoutAction } from "../redux/actions";
import { apiGetCurrentUser } from "../services/UsersService";
import { serviceAuthentication } from "../services/AuthenticationService";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

// styles
require("./UserInfo.css");

const UserInfo = () => {
  const { t } = useTranslation(undefined, { keyPrefix: `Users` });

  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const history = useHistory();
  const ref = useRef(null);

  useOnClickOutside(ref, () => setExpanded(false));

  const userInfo = useSelector((state: any) => state.userInfo);

  const onSignInClick = () => {
    history.push("/login");
  };

  const onSignOutClick = (e: any) => {
    e.preventDefault();
    serviceAuthentication.logout().then((responseData) => {
      dispatch(userLogoutAction(JSON.stringify(responseData.data)));
      window.location.href = '/login';
    });
  };
  
  return (
    <div ref={ref}>
      <div style={{ display: "flex" }}>
        <a
          className="nav-link Ripple-parent"
          rel="noopener noreferrer"
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          <i className="fa fa-github mr-2"></i>
          <i className="far fa-user"></i>
        </a>
        {userInfo.Anonymous && (
          <input
            type="button"
            className="btn btn-primary btn-sm"
            value={`${t('Login')}`}
            onClick={onSignInClick}
          />
        )}

        {!userInfo.Anonymous && (<>
          <div style={{ display: 'table', fontWeight: 'bold' }}>

            <a
              className="dropdown-toggle d-flex align-items-center hidden-arrow"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              data-mdb-toggle="dropdown"
              style={{cursor:'pointer'}}
              aria-expanded={expanded}
              onClick={() => {
                setExpanded(!expanded);
              }}
            >
              <div>{userInfo.Username}</div>
            </a>

            <div style={{ fontSize: '14px' }}>{userInfo.SellerName}</div>
          </div>

        </>)}
      </div>
      {
        expanded && (
          <ul
            className="dropdown-menu"
            style={{ display: "unset" }}
            aria-labelledby="navbarDropdownMenuLink"
          >
            {/* <li>
            <a className="dropdown-item" href="#">
              <i style={{ marginRight: "5px" }} className="fas fa-key"></i>
              Změna hesla
            </a>
          </li> */}
            <li>
              <a onClick={onSignOutClick} className="dropdown-item" href="#">
                <i
                  style={{ marginRight: "5px" }}
                  className="fas fa-sign-out-alt"
                ></i>
                {t('Logout')}
              </a>
            </li>
          </ul>
        )
      }
    </div >
  );
};

export default UserInfo;
